import { render } from "./ContactsHeader.vue?vue&type=template&id=1fd9eeb2"
import script from "./ContactsHeader.vue?vue&type=script&lang=js"
export * from "./ContactsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__